import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";

// Gemstones Data
const gemstones = [
  { name: "Red Ruby", image: "Red_Ruby.png" },
  { name: "Blue Sapphire", image: "Blue_Sapphire.png" },
  { name: "Pink Sapphire", image: "Pink_Sapphire.png" },
  { name: "Yellow Sapphire", image: "Yellow_Sapphire.png" },
  { name: "Green Emerald", image: "Green_Emerald.png" },
  { name: "Moissanite", image: "Moissanite.png" },
];

const GemstoneGlamour = () => {
  return (
    <section className="gemstone-glamour section-space">
      <Container fluid className="showcase-container">
        <Row>
          <Col md={6}>
            <Heading>
              <span>Colorful Charms</span>
              <h2>Gemstone Glamour</h2>
              <p>
                Dazzle with the brilliance of gemstone {Je_welryspelling}, each piece a
                testament to timeless beauty and individuality.
              </p>
            </Heading>

            <div className="gemstone-wrapper d-flex align-items-center justify-content-around">
              {gemstones.map(({ name, image }) => (
                <div key={name} className="item">
                  <Image src={`${ImageUrl}theme/showcase/gemstone/${image}`} alt={name} loading="lazy" />
                  <p>{name}</p>
                </div>
              ))}
            </div>

            <div className="text-center pt-3">
              <Link to="/gemstones" className="btn outline-base-btn large">
                Explore Now
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default GemstoneGlamour;
